// Turkse teksten van de to-do's in de ouderapp (zie todoApp.nl.ts).
export const appTodoTr = {
    tab: 'Yapılacaklar',
    repeatOption: 'Tarihsiz (yapılacak)',
    repeatHint: 'Tarih veya saat yok. Bitene kadar listede kalır.',
    description: 'Açıklama (isteğe bağlı)',
    dueDate: 'En geç (isteğe bağlı)',
    dueClear: 'Bitiş tarihi yok',
    from: '{name} ekledi',
    due: 'en geç {date}',
    emptyTitle: 'Yapılacak yok',
    emptyBody: 'Yapılacakların tarihi veya saati yoktur ve bitene kadar listede kalır. Örneğin: ayakkabı dolabını boyamak.',
    add: 'Yapılacak ekle',
    doneSection: 'Bitti',
    doneOn: '{date} tarihinde bitti',
    newTitle: 'Yeni yapılacak',
    editTitle: 'Yapılacağı düzenle',
    important: 'Önemli',
    importantHint: 'Küçük bir işaretle en üstte görünür.',
    assign: 'Şuna ata',
    assignHint: 'Bebekler ve küçük çocuklar yapılacak almaz.',
    assigned: '{names} kişisine atandı',
    // Oprichter 6 okt: privé to-do's in Mijn omgeving en de kaart op Vandaag.
    privateNote: 'Bu yapılacakları yalnızca sen görürsün. Ailen ve pano görmez. Panoda yalnızca, bunu bir tablet için kendin açıkça onaylarsan bir şey görünür; istediğin zaman kaldırabilirsin.',
    privateEntry: 'Özel bir yapılacak mı? Benim alanım içinde oluştur. Orada yalnızca sen görürsün.',
    privateEntryButton: 'Benim alanıma git',
    gateTitle: 'Kendi yapılacakların',
    gateBody: 'Kendi yapılacakların Benim alanım içinde durur. Onları yalnızca sen görürsün: ailen ve pano görmez. Panoda yalnızca, bunu bir tablet için kendin açıkça onaylarsan bir şey görünür; istediğin zaman kaldırabilirsin.',
    gateOpen: 'Benim alanımı aç',
    gateOpening: 'Açılıyor…',
    widgetEmpty: 'Açık yapılacak yok.',
    widgetAll: 'Tüm yapılacaklar',
    widgetMore: '+{count} daha',
    widgetFrom: '{name} hanesinden, yalnızca okuma',
    widgetOpenIn: '{name} içinde aç',
    widgetPending: 'Onay bekliyor',
};
//# sourceMappingURL=todoApp.tr.js.map